import { render } from "./VoiceCom.vue?vue&type=template&id=db85799c"
import script from "./VoiceCom.vue?vue&type=script&lang=js"
export * from "./VoiceCom.vue?vue&type=script&lang=js"

import "./VoiceCom.vue?vue&type=style&index=0&id=db85799c&lang=css"

import exportComponent from "/root/workspace/webFrontEnd_cs-mail-comment_sZq3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__